import e, { Fragment as t, createContext as n, forwardRef as r, memo as i, useCallback as a, useContext as o, useEffect as s, useImperativeHandle as c, useLayoutEffect as l, useMemo as u, useReducer as d, useRef as f, useState as p } from "react";
import { jsx as m, jsxs as h } from "react/jsx-runtime";
import g, { createPortal as _, unstable_batchedUpdates as v } from "react-dom";
//#region \0rolldown/runtime.js
var y = Object.create, b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, S = Object.getOwnPropertyNames, C = Object.getPrototypeOf, w = Object.prototype.hasOwnProperty, T = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), E = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = S(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !w.call(e, s) && s !== n && b(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = x(t, s)) || r.enumerable
	});
	return e;
}, D = (e, t, n) => (n = e == null ? {} : y(C(e)), E(t || !e || !e.__esModule ? b(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region src/hooks.ts
function O(e) {
	let t = f({ initialized: !1 });
	return t.current.initialized || (t.current = {
		initialized: !0,
		value: e()
	}), t.current.value;
}
var ee = (() => {
	let e = 0;
	return () => ++e;
})();
function k() {
	return O(ee);
}
//#endregion
//#region src/utils.ts
function A(e, t) {
	let { innerWidth: n, innerHeight: r } = window, { width: i, height: a } = t;
	return j(e, ([[e, t], [o, s]]) => ({
		left: e === "left" ? t : n - t - i,
		top: o === "top" ? s : r - s - a
	}));
}
function j(e, t) {
	return t(["left" in e ? ["left", e.left] : ["right", e.right], "top" in e ? ["top", e.top] : ["bottom", e.bottom]]);
}
function M(e) {
	return {
		x: "left" in e ? "left" : "right",
		y: "top" in e ? "top" : "bottom"
	};
}
function te(e, t, n) {
	let r = window.innerWidth, i = window.innerHeight;
	return {
		[n.x]: n.x === "left" ? "left" in e ? e.left : e.right - t.width : "right" in e ? e.right : r - (e.left + t.width),
		[n.y]: n.y === "top" ? "top" in e ? e.top : e.bottom - t.height : "bottom" in e ? e.bottom : i - (e.top + t.height)
	};
}
//#endregion
//#region src/positionFinder/defaultPositionFinder.ts
function N(e, t, n) {
	let { positionHint: r, margin: i = 8, container: a = P(i) } = n, o = (n) => {
		let { left: r, top: o } = n, { width: s, height: c } = t;
		if (a.left <= r && a.top <= o && r + s <= a.left + a.width && o + c <= a.top + a.height) {
			let t = {
				left: r,
				top: o,
				width: s,
				height: c
			};
			return !e.some((e) => re(t, e, i));
		}
		return !1;
	}, s = r ?? {
		left: a.left,
		top: a.top
	}, c = Infinity, l = s;
	for (let n of (function* () {
		yield s;
		for (let n of e) for (let e of [
			n.top,
			n.top + (n.height + i),
			n.top - (t.height + i),
			a.top,
			a.top + a.height - t.height
		]) for (let r of [
			n.left,
			n.left + (n.width + i),
			n.left - (t.width + i),
			a.left,
			a.left + a.width - t.width
		]) yield {
			top: e,
			left: r
		};
	})()) if (o(n)) {
		let e = ne(n, s);
		c > e && (c = e, l = n);
	}
	return te(l, t, n.origin);
}
function ne(e, t) {
	return (e.left - t.left) ** 2 + (e.top - t.top) ** 2;
}
function P(e) {
	return {
		top: e,
		left: e,
		width: window.innerWidth - 2 * e,
		height: window.innerHeight - 2 * e
	};
}
function re(e, t, n) {
	return t = ie(t, n), !(t.left + t.width <= e.left || e.left + e.width <= t.left) && !(t.top + t.height <= e.top || e.top + e.height <= t.top);
}
function ie(e, t) {
	return {
		left: e.left - t,
		top: e.top - t,
		width: e.width + 2 * t,
		height: e.height + 2 * t
	};
}
//#endregion
//#region src/setDisplayName.ts
function F(e) {
	for (let t of Object.keys(e)) e[t].displayName = t;
}
//#endregion
//#region src/Context.tsx
var I = n(void 0), L = r(({ children: e, portal: t, positionFinder: n = N, defaultPositionHint: r }, i) => {
	let o = O(() => /* @__PURE__ */ new Map()), [s, l] = p(/* @__PURE__ */ new Map()), [d, f] = p({});
	c(i, () => ({ rearrange: () => {
		o.clear(), f({});
	} }), [o]);
	let h = a((e) => {
		let t = s.get(e);
		l((e) => new Map([...e.entries()].sort((e, t) => e[1] - t[1]).map(([n, r], i) => [n, r === t ? e.size - 1 : r > t ? i - 1 : i])));
	}, [s]), g = u(() => ({
		dialogs: o,
		portal: t,
		nextPosition: (e, t) => n([...o.values()].map((e) => e.rect), e, {
			positionHint: t.positionHint,
			origin: t.origin
		}),
		zIndex: s,
		raiseDialog: h,
		defaultPositionHint: r,
		rearrangeTrigger: d
	}), [
		r,
		o,
		t,
		n,
		h,
		d,
		s
	]);
	return /* @__PURE__ */ m(I.Provider, {
		value: g,
		children: e
	});
});
F({ DialogContext: L });
function ae() {
	let e = o(I);
	if (e === void 0) throw Error("Use of useDialogContext outside its provider");
	return e;
}
//#endregion
//#region node_modules/@dnd-kit/utilities/dist/utilities.esm.js
var R = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0;
function z(e) {
	let t = Object.prototype.toString.call(e);
	return t === "[object Window]" || t === "[object global]";
}
function oe(e) {
	return "nodeType" in e;
}
function B(e) {
	return e ? z(e) ? e : oe(e) ? e.ownerDocument?.defaultView ?? window : window : window;
}
function se(e) {
	let { Document: t } = B(e);
	return e instanceof t;
}
function V(e) {
	return !z(e) && e instanceof B(e).HTMLElement;
}
function ce(e) {
	return e instanceof B(e).SVGElement;
}
function H(e) {
	return e ? z(e) ? e.document : oe(e) ? se(e) ? e : V(e) || ce(e) ? e.ownerDocument : document : document : document;
}
var le = R ? l : s;
function ue(e) {
	let t = f(e);
	return le(() => {
		t.current = e;
	}), a(function() {
		var e = [...arguments];
		return t.current == null ? void 0 : t.current(...e);
	}, []);
}
function de() {
	let e = f(null);
	return [a((t, n) => {
		e.current = setInterval(t, n);
	}, []), a(() => {
		e.current !== null && (clearInterval(e.current), e.current = null);
	}, [])];
}
function fe(e, t) {
	t === void 0 && (t = [e]);
	let n = f(e);
	return le(() => {
		n.current !== e && (n.current = e);
	}, t), n;
}
function U(e, t) {
	let n = f();
	return u(() => {
		let t = e(n.current);
		return n.current = t, t;
	}, [...t]);
}
function W(e) {
	let t = ue(e), n = f(null);
	return [n, a((e) => {
		e !== n.current && t?.(e, n.current), n.current = e;
	}, [])];
}
function pe(e) {
	let t = f();
	return s(() => {
		t.current = e;
	}, [e]), t.current;
}
var me = {};
function he(e, t) {
	return u(() => {
		if (t) return t;
		let n = me[e] == null ? 0 : me[e] + 1;
		return me[e] = n, e + "-" + n;
	}, [e, t]);
}
function ge(e) {
	return function(t) {
		return [...arguments].slice(1).reduce((t, n) => {
			let r = Object.entries(n);
			for (let [n, i] of r) {
				let r = t[n];
				r != null && (t[n] = r + e * i);
			}
			return t;
		}, { ...t });
	};
}
var _e = /*#__PURE__*/ ge(1), G = /*#__PURE__*/ ge(-1);
function ve(e) {
	return "clientX" in e && "clientY" in e;
}
function ye(e) {
	if (!e) return !1;
	let { KeyboardEvent: t } = B(e.target);
	return t && e instanceof t;
}
function be(e) {
	if (!e) return !1;
	let { TouchEvent: t } = B(e.target);
	return t && e instanceof t;
}
function xe(e) {
	if (be(e)) {
		if (e.touches && e.touches.length) {
			let { clientX: t, clientY: n } = e.touches[0];
			return {
				x: t,
				y: n
			};
		} else if (e.changedTouches && e.changedTouches.length) {
			let { clientX: t, clientY: n } = e.changedTouches[0];
			return {
				x: t,
				y: n
			};
		}
	}
	return ve(e) ? {
		x: e.clientX,
		y: e.clientY
	} : null;
}
var Se = /*#__PURE__*/ Object.freeze({
	Translate: { toString(e) {
		if (!e) return;
		let { x: t, y: n } = e;
		return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
	} },
	Scale: { toString(e) {
		if (!e) return;
		let { scaleX: t, scaleY: n } = e;
		return "scaleX(" + t + ") scaleY(" + n + ")";
	} },
	Transform: { toString(e) {
		if (e) return [Se.Translate.toString(e), Se.Scale.toString(e)].join(" ");
	} },
	Transition: { toString(e) {
		let { property: t, duration: n, easing: r } = e;
		return t + " " + n + "ms " + r;
	} }
}), Ce = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function we(e) {
	return e.matches(Ce) ? e : e.querySelector(Ce);
}
//#endregion
//#region node_modules/@dnd-kit/accessibility/dist/accessibility.esm.js
var Te = { display: "none" };
function Ee(t) {
	let { id: n, value: r } = t;
	return e.createElement("div", {
		id: n,
		style: Te
	}, r);
}
function De(t) {
	let { id: n, announcement: r, ariaLiveType: i = "assertive" } = t;
	return e.createElement("div", {
		id: n,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			width: 1,
			height: 1,
			margin: -1,
			border: 0,
			padding: 0,
			overflow: "hidden",
			clip: "rect(0 0 0 0)",
			clipPath: "inset(100%)",
			whiteSpace: "nowrap"
		},
		role: "status",
		"aria-live": i,
		"aria-atomic": !0
	}, r);
}
function Oe() {
	let [e, t] = p("");
	return {
		announce: a((e) => {
			e != null && t(e);
		}, []),
		announcement: e
	};
}
//#endregion
//#region node_modules/@dnd-kit/core/dist/core.esm.js
var ke = /*#__PURE__*/ n(null);
function Ae(e) {
	let t = o(ke);
	s(() => {
		if (!t) throw Error("useDndMonitor must be used within a children of <DndContext>");
		return t(e);
	}, [e, t]);
}
function je() {
	let [e] = p(() => /* @__PURE__ */ new Set()), t = a((t) => (e.add(t), () => e.delete(t)), [e]);
	return [a((t) => {
		let { type: n, event: r } = t;
		e.forEach((e) => e[n]?.call(e, r));
	}, [e]), t];
}
var Me = { draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  " }, Ne = {
	onDragStart(e) {
		let { active: t } = e;
		return "Picked up draggable item " + t.id + ".";
	},
	onDragOver(e) {
		let { active: t, over: n } = e;
		return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
	},
	onDragEnd(e) {
		let { active: t, over: n } = e;
		return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
	},
	onDragCancel(e) {
		let { active: t } = e;
		return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
	}
};
function Pe(t) {
	let { announcements: n = Ne, container: r, hiddenTextDescribedById: i, screenReaderInstructions: a = Me } = t, { announce: o, announcement: c } = Oe(), l = he("DndLiveRegion"), [d, f] = p(!1);
	if (s(() => {
		f(!0);
	}, []), Ae(u(() => ({
		onDragStart(e) {
			let { active: t } = e;
			o(n.onDragStart({ active: t }));
		},
		onDragMove(e) {
			let { active: t, over: r } = e;
			n.onDragMove && o(n.onDragMove({
				active: t,
				over: r
			}));
		},
		onDragOver(e) {
			let { active: t, over: r } = e;
			o(n.onDragOver({
				active: t,
				over: r
			}));
		},
		onDragEnd(e) {
			let { active: t, over: r } = e;
			o(n.onDragEnd({
				active: t,
				over: r
			}));
		},
		onDragCancel(e) {
			let { active: t, over: r } = e;
			o(n.onDragCancel({
				active: t,
				over: r
			}));
		}
	}), [o, n])), !d) return null;
	let m = e.createElement(e.Fragment, null, e.createElement(Ee, {
		id: i,
		value: a.draggable
	}), e.createElement(De, {
		id: l,
		announcement: c
	}));
	return r ? _(m, r) : m;
}
var K;
(function(e) {
	e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(K ||= {});
function Fe() {}
function Ie(e, t) {
	return u(() => ({
		sensor: e,
		options: t ?? {}
	}), [e, t]);
}
function Le() {
	var e = [...arguments];
	return u(() => [...e].filter((e) => e != null), [...e]);
}
var q = /*#__PURE__*/ Object.freeze({
	x: 0,
	y: 0
});
function Re(e, t) {
	let { data: { value: n } } = e, { data: { value: r } } = t;
	return r - n;
}
function ze(e, t) {
	if (!e || e.length === 0) return null;
	let [n] = e;
	return t ? n[t] : n;
}
function Be(e, t) {
	let n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), i = Math.min(t.left + t.width, e.left + e.width), a = Math.min(t.top + t.height, e.top + e.height), o = i - r, s = a - n;
	if (r < i && n < a) {
		let n = t.width * t.height, r = e.width * e.height, i = o * s, a = i / (n + r - i);
		return Number(a.toFixed(4));
	}
	return 0;
}
var Ve = (e) => {
	let { collisionRect: t, droppableRects: n, droppableContainers: r } = e, i = [];
	for (let e of r) {
		let { id: r } = e, a = n.get(r);
		if (a) {
			let n = Be(a, t);
			n > 0 && i.push({
				id: r,
				data: {
					droppableContainer: e,
					value: n
				}
			});
		}
	}
	return i.sort(Re);
};
function He(e, t, n) {
	return {
		...e,
		scaleX: t && n ? t.width / n.width : 1,
		scaleY: t && n ? t.height / n.height : 1
	};
}
function Ue(e, t) {
	return e && t ? {
		x: e.left - t.left,
		y: e.top - t.top
	} : q;
}
function We(e) {
	return function(t) {
		return [...arguments].slice(1).reduce((t, n) => ({
			...t,
			top: t.top + e * n.y,
			bottom: t.bottom + e * n.y,
			left: t.left + e * n.x,
			right: t.right + e * n.x
		}), { ...t });
	};
}
var Ge = /*#__PURE__*/ We(1);
function Ke(e) {
	if (e.startsWith("matrix3d(")) {
		let t = e.slice(9, -1).split(/, /);
		return {
			x: +t[12],
			y: +t[13],
			scaleX: +t[0],
			scaleY: +t[5]
		};
	} else if (e.startsWith("matrix(")) {
		let t = e.slice(7, -1).split(/, /);
		return {
			x: +t[4],
			y: +t[5],
			scaleX: +t[0],
			scaleY: +t[3]
		};
	}
	return null;
}
function qe(e, t, n) {
	let r = Ke(t);
	if (!r) return e;
	let { scaleX: i, scaleY: a, x: o, y: s } = r, c = e.left - o - (1 - i) * parseFloat(n), l = e.top - s - (1 - a) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = i ? e.width / i : e.width, d = a ? e.height / a : e.height;
	return {
		width: u,
		height: d,
		top: l,
		right: c + u,
		bottom: l + d,
		left: c
	};
}
var Je = { ignoreTransform: !1 };
function Ye(e, t) {
	t === void 0 && (t = Je);
	let n = e.getBoundingClientRect();
	if (t.ignoreTransform) {
		let { transform: t, transformOrigin: r } = B(e).getComputedStyle(e);
		t && (n = qe(n, t, r));
	}
	let { top: r, left: i, width: a, height: o, bottom: s, right: c } = n;
	return {
		top: r,
		left: i,
		width: a,
		height: o,
		bottom: s,
		right: c
	};
}
function Xe(e) {
	return Ye(e, { ignoreTransform: !0 });
}
function Ze(e) {
	let t = e.innerWidth, n = e.innerHeight;
	return {
		top: 0,
		left: 0,
		right: t,
		bottom: n,
		width: t,
		height: n
	};
}
function Qe(e, t) {
	return t === void 0 && (t = B(e).getComputedStyle(e)), t.position === "fixed";
}
function $e(e, t) {
	t === void 0 && (t = B(e).getComputedStyle(e));
	let n = /(auto|scroll|overlay)/;
	return [
		"overflow",
		"overflowX",
		"overflowY"
	].some((e) => {
		let r = t[e];
		return typeof r == "string" && n.test(r);
	});
}
function et(e, t) {
	let n = [];
	function r(i) {
		if (t != null && n.length >= t || !i) return n;
		if (se(i) && i.scrollingElement != null && !n.includes(i.scrollingElement)) return n.push(i.scrollingElement), n;
		if (!V(i) || ce(i) || n.includes(i)) return n;
		let a = B(e).getComputedStyle(i);
		return i !== e && $e(i, a) && n.push(i), Qe(i, a) ? n : r(i.parentNode);
	}
	return e ? r(e) : n;
}
function tt(e) {
	let [t] = et(e, 1);
	return t ?? null;
}
function nt(e) {
	return !R || !e ? null : z(e) ? e : oe(e) ? se(e) || e === H(e).scrollingElement ? window : V(e) ? e : null : null;
}
function rt(e) {
	return z(e) ? e.scrollX : e.scrollLeft;
}
function it(e) {
	return z(e) ? e.scrollY : e.scrollTop;
}
function at(e) {
	return {
		x: rt(e),
		y: it(e)
	};
}
var J;
(function(e) {
	e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(J ||= {});
function ot(e) {
	return !R || !e ? !1 : e === document.scrollingElement;
}
function st(e) {
	let t = {
		x: 0,
		y: 0
	}, n = ot(e) ? {
		height: window.innerHeight,
		width: window.innerWidth
	} : {
		height: e.clientHeight,
		width: e.clientWidth
	}, r = {
		x: e.scrollWidth - n.width,
		y: e.scrollHeight - n.height
	};
	return {
		isTop: e.scrollTop <= t.y,
		isLeft: e.scrollLeft <= t.x,
		isBottom: e.scrollTop >= r.y,
		isRight: e.scrollLeft >= r.x,
		maxScroll: r,
		minScroll: t
	};
}
var ct = {
	x: .2,
	y: .2
};
function lt(e, t, n, r, i) {
	let { top: a, left: o, right: s, bottom: c } = n;
	r === void 0 && (r = 10), i === void 0 && (i = ct);
	let { isTop: l, isBottom: u, isLeft: d, isRight: f } = st(e), p = {
		x: 0,
		y: 0
	}, m = {
		x: 0,
		y: 0
	}, h = {
		height: t.height * i.y,
		width: t.width * i.x
	};
	return !l && a <= t.top + h.height ? (p.y = J.Backward, m.y = r * Math.abs((t.top + h.height - a) / h.height)) : !u && c >= t.bottom - h.height && (p.y = J.Forward, m.y = r * Math.abs((t.bottom - h.height - c) / h.height)), !f && s >= t.right - h.width ? (p.x = J.Forward, m.x = r * Math.abs((t.right - h.width - s) / h.width)) : !d && o <= t.left + h.width && (p.x = J.Backward, m.x = r * Math.abs((t.left + h.width - o) / h.width)), {
		direction: p,
		speed: m
	};
}
function ut(e) {
	if (e === document.scrollingElement) {
		let { innerWidth: e, innerHeight: t } = window;
		return {
			top: 0,
			left: 0,
			right: e,
			bottom: t,
			width: e,
			height: t
		};
	}
	let { top: t, left: n, right: r, bottom: i } = e.getBoundingClientRect();
	return {
		top: t,
		left: n,
		right: r,
		bottom: i,
		width: e.clientWidth,
		height: e.clientHeight
	};
}
function dt(e) {
	return e.reduce((e, t) => _e(e, at(t)), q);
}
function ft(e) {
	return e.reduce((e, t) => e + rt(t), 0);
}
function pt(e) {
	return e.reduce((e, t) => e + it(t), 0);
}
function mt(e, t) {
	if (t === void 0 && (t = Ye), !e) return;
	let { top: n, left: r, bottom: i, right: a } = t(e);
	tt(e) && (i <= 0 || a <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
		block: "center",
		inline: "center"
	});
}
var ht = [[
	"x",
	["left", "right"],
	ft
], [
	"y",
	["top", "bottom"],
	pt
]], gt = class {
	constructor(e, t) {
		this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
		let n = et(t), r = dt(n);
		this.rect = { ...e }, this.width = e.width, this.height = e.height;
		for (let [e, t, i] of ht) for (let a of t) Object.defineProperty(this, a, {
			get: () => {
				let t = i(n), o = r[e] - t;
				return this.rect[a] + o;
			},
			enumerable: !0
		});
		Object.defineProperty(this, "rect", { enumerable: !1 });
	}
}, _t = class {
	constructor(e) {
		this.target = void 0, this.listeners = [], this.removeAll = () => {
			this.listeners.forEach((e) => this.target?.removeEventListener(...e));
		}, this.target = e;
	}
	add(e, t, n) {
		var r;
		(r = this.target) == null || r.addEventListener(e, t, n), this.listeners.push([
			e,
			t,
			n
		]);
	}
};
function vt(e) {
	let { EventTarget: t } = B(e);
	return e instanceof t ? e : H(e);
}
function yt(e, t) {
	let n = Math.abs(e.x), r = Math.abs(e.y);
	return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t && r > t.y;
}
var Y;
(function(e) {
	e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Y ||= {});
function bt(e) {
	e.preventDefault();
}
function xt(e) {
	e.stopPropagation();
}
var X;
(function(e) {
	e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(X ||= {});
var St = {
	start: [X.Space, X.Enter],
	cancel: [X.Esc],
	end: [
		X.Space,
		X.Enter,
		X.Tab
	]
}, Ct = (e, t) => {
	let { currentCoordinates: n } = t;
	switch (e.code) {
		case X.Right: return {
			...n,
			x: n.x + 25
		};
		case X.Left: return {
			...n,
			x: n.x - 25
		};
		case X.Down: return {
			...n,
			y: n.y + 25
		};
		case X.Up: return {
			...n,
			y: n.y - 25
		};
	}
}, wt = class {
	constructor(e) {
		this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = e;
		let { event: { target: t } } = e;
		this.props = e, this.listeners = new _t(H(t)), this.windowListeners = new _t(B(t)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
	}
	attach() {
		this.handleStart(), this.windowListeners.add(Y.Resize, this.handleCancel), this.windowListeners.add(Y.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Y.Keydown, this.handleKeyDown));
	}
	handleStart() {
		let { activeNode: e, onStart: t } = this.props, n = e.node.current;
		n && mt(n), t(q);
	}
	handleKeyDown(e) {
		if (ye(e)) {
			let { active: t, context: n, options: r } = this.props, { keyboardCodes: i = St, coordinateGetter: a = Ct, scrollBehavior: o = "smooth" } = r, { code: s } = e;
			if (i.end.includes(s)) {
				this.handleEnd(e);
				return;
			}
			if (i.cancel.includes(s)) {
				this.handleCancel(e);
				return;
			}
			let { collisionRect: c } = n.current, l = c ? {
				x: c.left,
				y: c.top
			} : q;
			this.referenceCoordinates ||= l;
			let u = a(e, {
				active: t,
				context: n.current,
				currentCoordinates: l
			});
			if (u) {
				let t = G(u, l), r = {
					x: 0,
					y: 0
				}, { scrollableAncestors: i } = n.current;
				for (let n of i) {
					let i = e.code, { isTop: a, isRight: s, isLeft: c, isBottom: l, maxScroll: d, minScroll: f } = st(n), p = ut(n), m = {
						x: Math.min(i === X.Right ? p.right - p.width / 2 : p.right, Math.max(i === X.Right ? p.left : p.left + p.width / 2, u.x)),
						y: Math.min(i === X.Down ? p.bottom - p.height / 2 : p.bottom, Math.max(i === X.Down ? p.top : p.top + p.height / 2, u.y))
					}, h = i === X.Right && !s || i === X.Left && !c, g = i === X.Down && !l || i === X.Up && !a;
					if (h && m.x !== u.x) {
						let e = n.scrollLeft + t.x, a = i === X.Right && e <= d.x || i === X.Left && e >= f.x;
						if (a && !t.y) {
							n.scrollTo({
								left: e,
								behavior: o
							});
							return;
						}
						a ? r.x = n.scrollLeft - e : r.x = i === X.Right ? n.scrollLeft - d.x : n.scrollLeft - f.x, r.x && n.scrollBy({
							left: -r.x,
							behavior: o
						});
						break;
					} else if (g && m.y !== u.y) {
						let e = n.scrollTop + t.y, a = i === X.Down && e <= d.y || i === X.Up && e >= f.y;
						if (a && !t.x) {
							n.scrollTo({
								top: e,
								behavior: o
							});
							return;
						}
						a ? r.y = n.scrollTop - e : r.y = i === X.Down ? n.scrollTop - d.y : n.scrollTop - f.y, r.y && n.scrollBy({
							top: -r.y,
							behavior: o
						});
						break;
					}
				}
				this.handleMove(e, _e(G(u, this.referenceCoordinates), r));
			}
		}
	}
	handleMove(e, t) {
		let { onMove: n } = this.props;
		e.preventDefault(), n(t);
	}
	handleEnd(e) {
		let { onEnd: t } = this.props;
		e.preventDefault(), this.detach(), t();
	}
	handleCancel(e) {
		let { onCancel: t } = this.props;
		e.preventDefault(), this.detach(), t();
	}
	detach() {
		this.listeners.removeAll(), this.windowListeners.removeAll();
	}
};
wt.activators = [{
	eventName: "onKeyDown",
	handler: (e, t, n) => {
		let { keyboardCodes: r = St, onActivation: i } = t, { active: a } = n, { code: o } = e.nativeEvent;
		if (r.start.includes(o)) {
			let t = a.activatorNode.current;
			return t && e.target !== t ? !1 : (e.preventDefault(), i?.({ event: e.nativeEvent }), !0);
		}
		return !1;
	}
}];
function Tt(e) {
	return !!(e && "distance" in e);
}
function Et(e) {
	return !!(e && "delay" in e);
}
var Dt = class {
	constructor(e, t, n) {
		n === void 0 && (n = vt(e.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = e, this.events = t;
		let { event: r } = e, { target: i } = r;
		this.props = e, this.events = t, this.document = H(i), this.documentListeners = new _t(this.document), this.listeners = new _t(n), this.windowListeners = new _t(B(i)), this.initialCoordinates = xe(r) ?? q, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
	}
	attach() {
		let { events: e, props: { options: { activationConstraint: t, bypassActivationConstraint: n } } } = this;
		if (this.listeners.add(e.move.name, this.handleMove, { passive: !1 }), this.listeners.add(e.end.name, this.handleEnd), e.cancel && this.listeners.add(e.cancel.name, this.handleCancel), this.windowListeners.add(Y.Resize, this.handleCancel), this.windowListeners.add(Y.DragStart, bt), this.windowListeners.add(Y.VisibilityChange, this.handleCancel), this.windowListeners.add(Y.ContextMenu, bt), this.documentListeners.add(Y.Keydown, this.handleKeydown), t) {
			if (n != null && n({
				event: this.props.event,
				activeNode: this.props.activeNode,
				options: this.props.options
			})) return this.handleStart();
			if (Et(t)) {
				this.timeoutId = setTimeout(this.handleStart, t.delay), this.handlePending(t);
				return;
			}
			if (Tt(t)) {
				this.handlePending(t);
				return;
			}
		}
		this.handleStart();
	}
	detach() {
		this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
	}
	handlePending(e, t) {
		let { active: n, onPending: r } = this.props;
		r(n, e, this.initialCoordinates, t);
	}
	handleStart() {
		let { initialCoordinates: e } = this, { onStart: t } = this.props;
		e && (this.activated = !0, this.documentListeners.add(Y.Click, xt, { capture: !0 }), this.removeTextSelection(), this.documentListeners.add(Y.SelectionChange, this.removeTextSelection), t(e));
	}
	handleMove(e) {
		let { activated: t, initialCoordinates: n, props: r } = this, { onMove: i, options: { activationConstraint: a } } = r;
		if (!n) return;
		let o = xe(e) ?? q, s = G(n, o);
		if (!t && a) {
			if (Tt(a)) {
				if (a.tolerance != null && yt(s, a.tolerance)) return this.handleCancel();
				if (yt(s, a.distance)) return this.handleStart();
			}
			if (Et(a) && yt(s, a.tolerance)) return this.handleCancel();
			this.handlePending(a, s);
			return;
		}
		e.cancelable && e.preventDefault(), i(o);
	}
	handleEnd() {
		let { onAbort: e, onEnd: t } = this.props;
		this.detach(), this.activated || e(this.props.active), t();
	}
	handleCancel() {
		let { onAbort: e, onCancel: t } = this.props;
		this.detach(), this.activated || e(this.props.active), t();
	}
	handleKeydown(e) {
		e.code === X.Esc && this.handleCancel();
	}
	removeTextSelection() {
		var e;
		(e = this.document.getSelection()) == null || e.removeAllRanges();
	}
}, Ot = {
	cancel: { name: "pointercancel" },
	move: { name: "pointermove" },
	end: { name: "pointerup" }
}, kt = class extends Dt {
	constructor(e) {
		let { event: t } = e, n = H(t.target);
		super(e, Ot, n);
	}
};
kt.activators = [{
	eventName: "onPointerDown",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t;
		return !n.isPrimary || n.button !== 0 ? !1 : (r?.({ event: n }), !0);
	}
}];
var At = {
	move: { name: "mousemove" },
	end: { name: "mouseup" }
}, jt;
(function(e) {
	e[e.RightClick = 2] = "RightClick";
})(jt ||= {});
var Mt = class extends Dt {
	constructor(e) {
		super(e, At, H(e.event.target));
	}
};
Mt.activators = [{
	eventName: "onMouseDown",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t;
		return n.button === jt.RightClick ? !1 : (r?.({ event: n }), !0);
	}
}];
var Nt = {
	cancel: { name: "touchcancel" },
	move: { name: "touchmove" },
	end: { name: "touchend" }
}, Pt = class extends Dt {
	constructor(e) {
		super(e, Nt);
	}
	static setup() {
		return window.addEventListener(Nt.move.name, e, {
			capture: !1,
			passive: !1
		}), function() {
			window.removeEventListener(Nt.move.name, e);
		};
		function e() {}
	}
};
Pt.activators = [{
	eventName: "onTouchStart",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t, { touches: i } = n;
		return i.length > 1 ? !1 : (r?.({ event: n }), !0);
	}
}];
var Ft;
(function(e) {
	e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Ft ||= {});
var It;
(function(e) {
	e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(It ||= {});
function Lt(e) {
	let { acceleration: t, activator: n = Ft.Pointer, canScroll: r, draggingRect: i, enabled: o, interval: c = 5, order: l = It.TreeOrder, pointerCoordinates: d, scrollableAncestors: p, scrollableAncestorRects: m, delta: h, threshold: g } = e, _ = zt({
		delta: h,
		disabled: !o
	}), [v, y] = de(), b = f({
		x: 0,
		y: 0
	}), x = f({
		x: 0,
		y: 0
	}), S = u(() => {
		switch (n) {
			case Ft.Pointer: return d ? {
				top: d.y,
				bottom: d.y,
				left: d.x,
				right: d.x
			} : null;
			case Ft.DraggableRect: return i;
		}
	}, [
		n,
		i,
		d
	]), C = f(null), w = a(() => {
		let e = C.current;
		if (!e) return;
		let t = b.current.x * x.current.x, n = b.current.y * x.current.y;
		e.scrollBy(t, n);
	}, []), T = u(() => l === It.TreeOrder ? [...p].reverse() : p, [l, p]);
	s(() => {
		if (!o || !p.length || !S) {
			y();
			return;
		}
		for (let e of T) {
			if (r?.(e) === !1) continue;
			let n = p.indexOf(e), i = m[n];
			if (!i) continue;
			let { direction: a, speed: o } = lt(e, i, S, t, g);
			for (let e of ["x", "y"]) _[e][a[e]] || (o[e] = 0, a[e] = 0);
			if (o.x > 0 || o.y > 0) {
				y(), C.current = e, v(w, c), b.current = o, x.current = a;
				return;
			}
		}
		b.current = {
			x: 0,
			y: 0
		}, x.current = {
			x: 0,
			y: 0
		}, y();
	}, [
		t,
		w,
		r,
		y,
		o,
		c,
		JSON.stringify(S),
		JSON.stringify(_),
		v,
		p,
		T,
		m,
		JSON.stringify(g)
	]);
}
var Rt = {
	x: {
		[J.Backward]: !1,
		[J.Forward]: !1
	},
	y: {
		[J.Backward]: !1,
		[J.Forward]: !1
	}
};
function zt(e) {
	let { delta: t, disabled: n } = e, r = pe(t);
	return U((e) => {
		if (n || !r || !e) return Rt;
		let i = {
			x: Math.sign(t.x - r.x),
			y: Math.sign(t.y - r.y)
		};
		return {
			x: {
				[J.Backward]: e.x[J.Backward] || i.x === -1,
				[J.Forward]: e.x[J.Forward] || i.x === 1
			},
			y: {
				[J.Backward]: e.y[J.Backward] || i.y === -1,
				[J.Forward]: e.y[J.Forward] || i.y === 1
			}
		};
	}, [
		n,
		t,
		r
	]);
}
function Bt(e, t) {
	let n = t == null ? void 0 : e.get(t), r = n ? n.node.current : null;
	return U((e) => t == null ? null : r ?? e ?? null, [r, t]);
}
function Vt(e, t) {
	return u(() => e.reduce((e, n) => {
		let { sensor: r } = n, i = r.activators.map((e) => ({
			eventName: e.eventName,
			handler: t(e.handler, n)
		}));
		return [...e, ...i];
	}, []), [e, t]);
}
var Ht;
(function(e) {
	e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Ht ||= {});
var Ut;
(function(e) {
	e.Optimized = "optimized";
})(Ut ||= {});
var Wt = /*#__PURE__*/ new Map();
function Gt(e, t) {
	let { dragging: n, dependencies: r, config: i } = t, [o, c] = p(null), { frequency: l, measure: u, strategy: d } = i, m = f(e), h = b(), g = fe(h), _ = a(function(e) {
		e === void 0 && (e = []), !g.current && c((t) => t === null ? e : t.concat(e.filter((e) => !t.includes(e))));
	}, [g]), v = f(null), y = U((t) => {
		if (h && !n) return Wt;
		if (!t || t === Wt || m.current !== e || o != null) {
			let t = /* @__PURE__ */ new Map();
			for (let n of e) {
				if (!n) continue;
				if (o && o.length > 0 && !o.includes(n.id) && n.rect.current) {
					t.set(n.id, n.rect.current);
					continue;
				}
				let e = n.node.current, r = e ? new gt(u(e), e) : null;
				n.rect.current = r, r && t.set(n.id, r);
			}
			return t;
		}
		return t;
	}, [
		e,
		o,
		n,
		h,
		u
	]);
	return s(() => {
		m.current = e;
	}, [e]), s(() => {
		h || _();
	}, [n, h]), s(() => {
		o && o.length > 0 && c(null);
	}, [JSON.stringify(o)]), s(() => {
		h || typeof l != "number" || v.current !== null || (v.current = setTimeout(() => {
			_(), v.current = null;
		}, l));
	}, [
		l,
		h,
		_,
		...r
	]), {
		droppableRects: y,
		measureDroppableContainers: _,
		measuringScheduled: o != null
	};
	function b() {
		switch (d) {
			case Ht.Always: return !1;
			case Ht.BeforeDragging: return n;
			default: return !n;
		}
	}
}
function Kt(e, t) {
	return U((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function qt(e, t) {
	return Kt(e, t);
}
function Jt(e) {
	let { callback: t, disabled: n } = e, r = ue(t), i = u(() => {
		if (n || typeof window > "u" || window.MutationObserver === void 0) return;
		let { MutationObserver: e } = window;
		return new e(r);
	}, [r, n]);
	return s(() => () => i?.disconnect(), [i]), i;
}
function Yt(e) {
	let { callback: t, disabled: n } = e, r = ue(t), i = u(() => {
		if (n || typeof window > "u" || window.ResizeObserver === void 0) return;
		let { ResizeObserver: e } = window;
		return new e(r);
	}, [n]);
	return s(() => () => i?.disconnect(), [i]), i;
}
function Xt(e) {
	return new gt(Ye(e), e);
}
function Zt(e, t, n) {
	t === void 0 && (t = Xt);
	let [r, i] = p(null);
	function a() {
		i((r) => {
			if (!e) return null;
			if (e.isConnected === !1) return r ?? n ?? null;
			let i = t(e);
			return JSON.stringify(r) === JSON.stringify(i) ? r : i;
		});
	}
	let o = Jt({ callback(t) {
		if (e) for (let n of t) {
			let { type: t, target: r } = n;
			if (t === "childList" && r instanceof HTMLElement && r.contains(e)) {
				a();
				break;
			}
		}
	} }), s = Yt({ callback: a });
	return le(() => {
		a(), e ? (s?.observe(e), o?.observe(document.body, {
			childList: !0,
			subtree: !0
		})) : (s?.disconnect(), o?.disconnect());
	}, [e]), r;
}
function Qt(e) {
	return Ue(e, Kt(e));
}
var $t = [];
function en(e) {
	let t = f(e), n = U((n) => e ? n && n !== $t && e && t.current && e.parentNode === t.current.parentNode ? n : et(e) : $t, [e]);
	return s(() => {
		t.current = e;
	}, [e]), n;
}
function tn(e) {
	let [t, n] = p(null), r = f(e), i = a((e) => {
		let t = nt(e.target);
		t && n((e) => e ? (e.set(t, at(t)), new Map(e)) : null);
	}, []);
	return s(() => {
		let t = r.current;
		if (e !== t) {
			a(t);
			let o = e.map((e) => {
				let t = nt(e);
				return t ? (t.addEventListener("scroll", i, { passive: !0 }), [t, at(t)]) : null;
			}).filter((e) => e != null);
			n(o.length ? new Map(o) : null), r.current = e;
		}
		return () => {
			a(e), a(t);
		};
		function a(e) {
			e.forEach((e) => {
				nt(e)?.removeEventListener("scroll", i);
			});
		}
	}, [i, e]), u(() => e.length ? t ? Array.from(t.values()).reduce((e, t) => _e(e, t), q) : dt(e) : q, [e, t]);
}
function nn(e, t) {
	t === void 0 && (t = []);
	let n = f(null);
	return s(() => {
		n.current = null;
	}, t), s(() => {
		let t = e !== q;
		t && !n.current && (n.current = e), !t && n.current && (n.current = null);
	}, [e]), n.current ? G(e, n.current) : q;
}
function rn(e) {
	s(() => {
		if (!R) return;
		let t = e.map((e) => {
			let { sensor: t } = e;
			return t.setup == null ? void 0 : t.setup();
		});
		return () => {
			for (let e of t) e?.();
		};
	}, e.map((e) => {
		let { sensor: t } = e;
		return t;
	}));
}
function an(e, t) {
	return u(() => e.reduce((e, n) => {
		let { eventName: r, handler: i } = n;
		return e[r] = (e) => {
			i(e, t);
		}, e;
	}, {}), [e, t]);
}
function on(e) {
	return u(() => e ? Ze(e) : null, [e]);
}
var sn = [];
function cn(e, t) {
	t === void 0 && (t = Ye);
	let [n] = e, r = on(n ? B(n) : null), [i, a] = p(sn);
	function o() {
		a(() => e.length ? e.map((e) => ot(e) ? r : new gt(t(e), e)) : sn);
	}
	let s = Yt({ callback: o });
	return le(() => {
		s?.disconnect(), o(), e.forEach((e) => s?.observe(e));
	}, [e]), i;
}
function ln(e) {
	if (!e) return null;
	if (e.children.length > 1) return e;
	let t = e.children[0];
	return V(t) ? t : e;
}
function un(e) {
	let { measure: t } = e, [n, r] = p(null), i = Yt({ callback: a((e) => {
		for (let { target: n } of e) if (V(n)) {
			r((e) => {
				let r = t(n);
				return e ? {
					...e,
					width: r.width,
					height: r.height
				} : r;
			});
			break;
		}
	}, [t]) }), [o, s] = W(a((e) => {
		let n = ln(e);
		i?.disconnect(), n && i?.observe(n), r(n ? t(n) : null);
	}, [t, i]));
	return u(() => ({
		nodeRef: o,
		rect: n,
		setRef: s
	}), [
		n,
		o,
		s
	]);
}
var dn = [{
	sensor: kt,
	options: {}
}, {
	sensor: wt,
	options: {}
}], fn = { current: {} }, pn = {
	draggable: { measure: Xe },
	droppable: {
		measure: Xe,
		strategy: Ht.WhileDragging,
		frequency: Ut.Optimized
	},
	dragOverlay: { measure: Ye }
}, mn = class extends Map {
	get(e) {
		return e == null ? void 0 : super.get(e) ?? void 0;
	}
	toArray() {
		return Array.from(this.values());
	}
	getEnabled() {
		return this.toArray().filter((e) => {
			let { disabled: t } = e;
			return !t;
		});
	}
	getNodeFor(e) {
		return this.get(e)?.node.current ?? void 0;
	}
}, hn = {
	activatorEvent: null,
	active: null,
	activeNode: null,
	activeNodeRect: null,
	collisions: null,
	containerNodeRect: null,
	draggableNodes: /*#__PURE__*/ new Map(),
	droppableRects: /*#__PURE__*/ new Map(),
	droppableContainers: /*#__PURE__*/ new mn(),
	over: null,
	dragOverlay: {
		nodeRef: { current: null },
		rect: null,
		setRef: Fe
	},
	scrollableAncestors: [],
	scrollableAncestorRects: [],
	measuringConfiguration: pn,
	measureDroppableContainers: Fe,
	windowRect: null,
	measuringScheduled: !1
}, gn = /*#__PURE__*/ n({
	activatorEvent: null,
	activators: [],
	active: null,
	activeNodeRect: null,
	ariaDescribedById: { draggable: "" },
	dispatch: Fe,
	draggableNodes: /*#__PURE__*/ new Map(),
	over: null,
	measureDroppableContainers: Fe
}), _n = /*#__PURE__*/ n(hn);
function vn() {
	return {
		draggable: {
			active: null,
			initialCoordinates: {
				x: 0,
				y: 0
			},
			nodes: /* @__PURE__ */ new Map(),
			translate: {
				x: 0,
				y: 0
			}
		},
		droppable: { containers: new mn() }
	};
}
function yn(e, t) {
	switch (t.type) {
		case K.DragStart: return {
			...e,
			draggable: {
				...e.draggable,
				initialCoordinates: t.initialCoordinates,
				active: t.active
			}
		};
		case K.DragMove: return e.draggable.active == null ? e : {
			...e,
			draggable: {
				...e.draggable,
				translate: {
					x: t.coordinates.x - e.draggable.initialCoordinates.x,
					y: t.coordinates.y - e.draggable.initialCoordinates.y
				}
			}
		};
		case K.DragEnd:
		case K.DragCancel: return {
			...e,
			draggable: {
				...e.draggable,
				active: null,
				initialCoordinates: {
					x: 0,
					y: 0
				},
				translate: {
					x: 0,
					y: 0
				}
			}
		};
		case K.RegisterDroppable: {
			let { element: n } = t, { id: r } = n, i = new mn(e.droppable.containers);
			return i.set(r, n), {
				...e,
				droppable: {
					...e.droppable,
					containers: i
				}
			};
		}
		case K.SetDroppableDisabled: {
			let { id: n, key: r, disabled: i } = t, a = e.droppable.containers.get(n);
			if (!a || r !== a.key) return e;
			let o = new mn(e.droppable.containers);
			return o.set(n, {
				...a,
				disabled: i
			}), {
				...e,
				droppable: {
					...e.droppable,
					containers: o
				}
			};
		}
		case K.UnregisterDroppable: {
			let { id: n, key: r } = t, i = e.droppable.containers.get(n);
			if (!i || r !== i.key) return e;
			let a = new mn(e.droppable.containers);
			return a.delete(n), {
				...e,
				droppable: {
					...e.droppable,
					containers: a
				}
			};
		}
		default: return e;
	}
}
function bn(e) {
	let { disabled: t } = e, { active: n, activatorEvent: r, draggableNodes: i } = o(gn), a = pe(r), c = pe(n?.id);
	return s(() => {
		if (!t && !r && a && c != null) {
			if (!ye(a) || document.activeElement === a.target) return;
			let e = i.get(c);
			if (!e) return;
			let { activatorNode: t, node: n } = e;
			if (!t.current && !n.current) return;
			requestAnimationFrame(() => {
				for (let e of [t.current, n.current]) {
					if (!e) continue;
					let t = we(e);
					if (t) {
						t.focus();
						break;
					}
				}
			});
		}
	}, [
		r,
		t,
		i,
		c,
		a
	]), null;
}
function xn(e, t) {
	let { transform: n, ...r } = t;
	return e != null && e.length ? e.reduce((e, t) => t({
		transform: e,
		...r
	}), n) : n;
}
function Sn(e) {
	return u(() => ({
		draggable: {
			...pn.draggable,
			...e?.draggable
		},
		droppable: {
			...pn.droppable,
			...e?.droppable
		},
		dragOverlay: {
			...pn.dragOverlay,
			...e?.dragOverlay
		}
	}), [
		e?.draggable,
		e?.droppable,
		e?.dragOverlay
	]);
}
function Cn(e) {
	let { activeNode: t, measure: n, initialRect: r, config: i = !0 } = e, a = f(!1), { x: o, y: s } = typeof i == "boolean" ? {
		x: i,
		y: i
	} : i;
	le(() => {
		if (!o && !s || !t) {
			a.current = !1;
			return;
		}
		if (a.current || !r) return;
		let e = t?.node.current;
		if (!e || e.isConnected === !1) return;
		let i = Ue(n(e), r);
		if (o || (i.x = 0), s || (i.y = 0), a.current = !0, Math.abs(i.x) > 0 || Math.abs(i.y) > 0) {
			let t = tt(e);
			t && t.scrollBy({
				top: i.y,
				left: i.x
			});
		}
	}, [
		t,
		o,
		s,
		r,
		n
	]);
}
var wn = /*#__PURE__*/ n({
	...q,
	scaleX: 1,
	scaleY: 1
}), Tn;
(function(e) {
	e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Tn ||= {});
var En = /*#__PURE__*/ i(function(t) {
	let { id: n, accessibility: r, autoScroll: i = !0, children: o, sensors: c = dn, collisionDetection: l = Ve, measuring: m, modifiers: h, ...g } = t, [_, y] = d(yn, void 0, vn), [b, x] = je(), [S, C] = p(Tn.Uninitialized), w = S === Tn.Initialized, { draggable: { active: T, nodes: E, translate: D }, droppable: { containers: O } } = _, ee = T == null ? null : E.get(T), k = f({
		initial: null,
		translated: null
	}), A = u(() => T == null ? null : {
		id: T,
		data: ee?.data ?? fn,
		rect: k
	}, [T, ee]), j = f(null), [M, te] = p(null), [N, ne] = p(null), P = fe(g, Object.values(g)), re = he("DndDescribedBy", n), ie = u(() => O.getEnabled(), [O]), F = Sn(m), { droppableRects: I, measureDroppableContainers: L, measuringScheduled: ae } = Gt(ie, {
		dragging: w,
		dependencies: [D.x, D.y],
		config: F.droppable
	}), R = Bt(E, T), z = u(() => N ? xe(N) : null, [N]), oe = Be(), se = qt(R, F.draggable.measure);
	Cn({
		activeNode: T == null ? null : E.get(T),
		config: oe.layoutShiftCompensation,
		initialRect: se,
		measure: F.draggable.measure
	});
	let V = Zt(R, F.draggable.measure, se), ce = Zt(R ? R.parentElement : null), H = f({
		activatorEvent: null,
		active: null,
		activeNode: R,
		collisionRect: null,
		collisions: null,
		droppableRects: I,
		draggableNodes: E,
		draggingNode: null,
		draggingNodeRect: null,
		droppableContainers: O,
		over: null,
		scrollableAncestors: [],
		scrollAdjustedTranslate: null
	}), ue = O.getNodeFor(H.current.over?.id), de = un({ measure: F.dragOverlay.measure }), U = de.nodeRef.current ?? R, W = w ? de.rect ?? V : null, pe = !!(de.nodeRef.current && de.rect), me = Qt(pe ? null : V), ge = on(U ? B(U) : null), G = en(w ? ue ?? R : null), ve = cn(G), ye = xn(h, {
		transform: {
			x: D.x - me.x,
			y: D.y - me.y,
			scaleX: 1,
			scaleY: 1
		},
		activatorEvent: N,
		active: A,
		activeNodeRect: V,
		containerNodeRect: ce,
		draggingNodeRect: W,
		over: H.current.over,
		overlayNodeRect: de.rect,
		scrollableAncestors: G,
		scrollableAncestorRects: ve,
		windowRect: ge
	}), be = z ? _e(z, D) : null, Se = tn(G), Ce = nn(Se), we = nn(Se, [V]), Te = _e(ye, Ce), Ee = W ? Ge(W, ye) : null, De = A && Ee ? l({
		active: A,
		collisionRect: Ee,
		droppableRects: I,
		droppableContainers: ie,
		pointerCoordinates: be
	}) : null, Oe = ze(De, "id"), [Ae, Me] = p(null), Ne = He(pe ? ye : _e(ye, we), Ae?.rect ?? null, V), Fe = f(null), Ie = a((e, t) => {
		let { sensor: n, options: r } = t;
		if (j.current == null) return;
		let i = E.get(j.current);
		if (!i) return;
		let a = e.nativeEvent, o = new n({
			active: j.current,
			activeNode: i,
			event: a,
			options: r,
			context: H,
			onAbort(e) {
				if (!E.get(e)) return;
				let { onDragAbort: t } = P.current, n = { id: e };
				t?.(n), b({
					type: "onDragAbort",
					event: n
				});
			},
			onPending(e, t, n, r) {
				if (!E.get(e)) return;
				let { onDragPending: i } = P.current, a = {
					id: e,
					constraint: t,
					initialCoordinates: n,
					offset: r
				};
				i?.(a), b({
					type: "onDragPending",
					event: a
				});
			},
			onStart(e) {
				let t = j.current;
				if (t == null) return;
				let n = E.get(t);
				if (!n) return;
				let { onDragStart: r } = P.current, i = {
					activatorEvent: a,
					active: {
						id: t,
						data: n.data,
						rect: k
					}
				};
				v(() => {
					r?.(i), C(Tn.Initializing), y({
						type: K.DragStart,
						initialCoordinates: e,
						active: t
					}), b({
						type: "onDragStart",
						event: i
					}), te(Fe.current), ne(a);
				});
			},
			onMove(e) {
				y({
					type: K.DragMove,
					coordinates: e
				});
			},
			onEnd: s(K.DragEnd),
			onCancel: s(K.DragCancel)
		});
		Fe.current = o;
		function s(e) {
			return async function() {
				let { active: t, collisions: n, over: r, scrollAdjustedTranslate: i } = H.current, o = null;
				if (t && i) {
					let { cancelDrop: s } = P.current;
					o = {
						activatorEvent: a,
						active: t,
						collisions: n,
						delta: i,
						over: r
					}, e === K.DragEnd && typeof s == "function" && await Promise.resolve(s(o)) && (e = K.DragCancel);
				}
				j.current = null, v(() => {
					y({ type: e }), C(Tn.Uninitialized), Me(null), te(null), ne(null), Fe.current = null;
					let t = e === K.DragEnd ? "onDragEnd" : "onDragCancel";
					if (o) {
						let e = P.current[t];
						e?.(o), b({
							type: t,
							event: o
						});
					}
				});
			};
		}
	}, [E]), Le = Vt(c, a((e, t) => (n, r) => {
		let i = n.nativeEvent, a = E.get(r);
		if (j.current !== null || !a || i.dndKit || i.defaultPrevented) return;
		let o = { active: a };
		e(n, t.options, o) === !0 && (i.dndKit = { capturedBy: t.sensor }, j.current = r, Ie(n, t));
	}, [E, Ie]));
	rn(c), le(() => {
		V && S === Tn.Initializing && C(Tn.Initialized);
	}, [V, S]), s(() => {
		let { onDragMove: e } = P.current, { active: t, activatorEvent: n, collisions: r, over: i } = H.current;
		if (!t || !n) return;
		let a = {
			active: t,
			activatorEvent: n,
			collisions: r,
			delta: {
				x: Te.x,
				y: Te.y
			},
			over: i
		};
		v(() => {
			e?.(a), b({
				type: "onDragMove",
				event: a
			});
		});
	}, [Te.x, Te.y]), s(() => {
		let { active: e, activatorEvent: t, collisions: n, droppableContainers: r, scrollAdjustedTranslate: i } = H.current;
		if (!e || j.current == null || !t || !i) return;
		let { onDragOver: a } = P.current, o = r.get(Oe), s = o && o.rect.current ? {
			id: o.id,
			rect: o.rect.current,
			data: o.data,
			disabled: o.disabled
		} : null, c = {
			active: e,
			activatorEvent: t,
			collisions: n,
			delta: {
				x: i.x,
				y: i.y
			},
			over: s
		};
		v(() => {
			Me(s), a?.(c), b({
				type: "onDragOver",
				event: c
			});
		});
	}, [Oe]), le(() => {
		H.current = {
			activatorEvent: N,
			active: A,
			activeNode: R,
			collisionRect: Ee,
			collisions: De,
			droppableRects: I,
			draggableNodes: E,
			draggingNode: U,
			draggingNodeRect: W,
			droppableContainers: O,
			over: Ae,
			scrollableAncestors: G,
			scrollAdjustedTranslate: Te
		}, k.current = {
			initial: W,
			translated: Ee
		};
	}, [
		A,
		R,
		De,
		Ee,
		E,
		U,
		W,
		I,
		O,
		Ae,
		G,
		Te
	]), Lt({
		...oe,
		delta: D,
		draggingRect: Ee,
		pointerCoordinates: be,
		scrollableAncestors: G,
		scrollableAncestorRects: ve
	});
	let q = u(() => ({
		active: A,
		activeNode: R,
		activeNodeRect: V,
		activatorEvent: N,
		collisions: De,
		containerNodeRect: ce,
		dragOverlay: de,
		draggableNodes: E,
		droppableContainers: O,
		droppableRects: I,
		over: Ae,
		measureDroppableContainers: L,
		scrollableAncestors: G,
		scrollableAncestorRects: ve,
		measuringConfiguration: F,
		measuringScheduled: ae,
		windowRect: ge
	}), [
		A,
		R,
		V,
		N,
		De,
		ce,
		de,
		E,
		O,
		I,
		Ae,
		L,
		G,
		ve,
		F,
		ae,
		ge
	]), Re = u(() => ({
		activatorEvent: N,
		activators: Le,
		active: A,
		activeNodeRect: V,
		ariaDescribedById: { draggable: re },
		dispatch: y,
		draggableNodes: E,
		over: Ae,
		measureDroppableContainers: L
	}), [
		N,
		Le,
		A,
		V,
		y,
		re,
		E,
		Ae,
		L
	]);
	return e.createElement(ke.Provider, { value: x }, e.createElement(gn.Provider, { value: Re }, e.createElement(_n.Provider, { value: q }, e.createElement(wn.Provider, { value: Ne }, o)), e.createElement(bn, { disabled: r?.restoreFocus === !1 })), e.createElement(Pe, {
		...r,
		hiddenTextDescribedById: re
	}));
	function Be() {
		let e = M?.autoScrollEnabled === !1, t = typeof i == "object" ? i.enabled === !1 : i === !1, n = w && !e && !t;
		return typeof i == "object" ? {
			...i,
			enabled: n
		} : { enabled: n };
	}
}), Dn = /*#__PURE__*/ n(null), On = "button", kn = "Draggable";
function An(e) {
	let { id: t, data: n, disabled: r = !1, attributes: i } = e, a = he(kn), { activators: s, activatorEvent: c, active: l, activeNodeRect: d, ariaDescribedById: f, draggableNodes: p, over: m } = o(gn), { role: h = On, roleDescription: g = "draggable", tabIndex: _ = 0 } = i ?? {}, v = l?.id === t, y = o(v ? wn : Dn), [b, x] = W(), [S, C] = W(), w = an(s, t), T = fe(n);
	return le(() => (p.set(t, {
		id: t,
		key: a,
		node: b,
		activatorNode: S,
		data: T
	}), () => {
		let e = p.get(t);
		e && e.key === a && p.delete(t);
	}), [p, t]), {
		active: l,
		activatorEvent: c,
		activeNodeRect: d,
		attributes: u(() => ({
			role: h,
			tabIndex: _,
			"aria-disabled": r,
			"aria-pressed": v && h === On ? !0 : void 0,
			"aria-roledescription": g,
			"aria-describedby": f.draggable
		}), [
			r,
			h,
			_,
			v,
			g,
			f.draggable
		]),
		isDragging: v,
		listeners: r ? void 0 : w,
		node: b,
		over: m,
		setNodeRef: x,
		setActivatorNodeRef: C,
		transform: y
	};
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/extends.js
var jn = /* @__PURE__ */ D((/* @__PURE__ */ T(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))(), 1);
function Mn() {
	return Mn = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Mn.apply(null, arguments);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function Nn(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function Pn(e, t) {
	return Pn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, Pn(e, t);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function Fn(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Pn(e, t);
}
//#endregion
//#region node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var In = /* @__PURE__ */ T(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Ln = /* @__PURE__ */ T(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, O = i, ee = h, k = m, A = r, j = o, M = a, te = f, N = !1;
		function ne(e) {
			return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(e) || x(e) === l;
		}
		function P(e) {
			return x(e) === u;
		}
		function re(e) {
			return x(e) === c;
		}
		function ie(e) {
			return x(e) === s;
		}
		function F(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function I(e) {
			return x(e) === d;
		}
		function L(e) {
			return x(e) === i;
		}
		function ae(e) {
			return x(e) === h;
		}
		function R(e) {
			return x(e) === m;
		}
		function z(e) {
			return x(e) === r;
		}
		function oe(e) {
			return x(e) === o;
		}
		function B(e) {
			return x(e) === a;
		}
		function se(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = O, e.Lazy = ee, e.Memo = k, e.Portal = A, e.Profiler = j, e.StrictMode = M, e.Suspense = te, e.isAsyncMode = ne, e.isConcurrentMode = P, e.isContextConsumer = re, e.isContextProvider = ie, e.isElement = F, e.isForwardRef = I, e.isFragment = L, e.isLazy = ae, e.isMemo = R, e.isPortal = z, e.isProfiler = oe, e.isStrictMode = B, e.isSuspense = se, e.isValidElementType = b, e.typeOf = x;
	})();
})), Rn = /* @__PURE__ */ T(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = In() : t.exports = Ln();
})), zn = /* @__PURE__ */ T(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Bn = /* @__PURE__ */ T(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), Vn = /* @__PURE__ */ T(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Hn = /* @__PURE__ */ T(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Bn(), i = {}, a = Vn();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), Un = /* @__PURE__ */ T(((e, t) => {
	var n = Rn(), r = zn(), i = Bn(), a = Vn(), o = Hn(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: E(),
			objectOf: w,
			oneOf: C,
			oneOfType: T,
			shape: O,
			exact: ee
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (j(s) !== e) {
					var c = M(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = j(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = j(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = j(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = N(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return M(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = j(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function T(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function E() {
			function e(e, t, n, r, i) {
				return k(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function D(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function O(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = j(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return D(r, a, o, l, M(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function ee(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = j(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return D(o, s, c, d, M(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function k(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(k);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!k(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !k(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function A(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function j(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : A(t, e) ? "symbol" : t;
		}
		function M(e) {
			if (e == null) return "" + e;
			var t = j(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function te(e) {
			var t = M(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function N(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), Wn = /* @__PURE__ */ T(((e, t) => {
	var n = Bn();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), Z = /* @__PURE__ */ D((/* @__PURE__ */ T(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Rn();
		t.exports = Un()(n.isElement, !0);
	} else t.exports = Wn()();
})))());
function Gn(e, t) {
	return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
//#endregion
//#region node_modules/dom-helpers/esm/addClass.js
function Kn(e, t) {
	e.classList ? e.classList.add(t) : Gn(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
//#endregion
//#region node_modules/dom-helpers/esm/removeClass.js
function qn(e, t) {
	return e.replace(RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Jn(e, t) {
	e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = qn(e.className, t) : e.setAttribute("class", qn(e.className && e.className.baseVal || "", t));
}
//#endregion
//#region node_modules/react-transition-group/esm/config.js
var Yn = { disabled: !1 }, Xn = process.env.NODE_ENV === "production" ? null : Z.default.oneOfType([Z.default.number, Z.default.shape({
	enter: Z.default.number,
	exit: Z.default.number,
	appear: Z.default.number
}).isRequired]), Zn = process.env.NODE_ENV === "production" ? null : Z.default.oneOfType([
	Z.default.string,
	Z.default.shape({
		enter: Z.default.string,
		exit: Z.default.string,
		active: Z.default.string
	}),
	Z.default.shape({
		enter: Z.default.string,
		enterDone: Z.default.string,
		enterActive: Z.default.string,
		exit: Z.default.string,
		exitDone: Z.default.string,
		exitActive: Z.default.string
	})
]), Qn = e.createContext(null), $n = function(e) {
	return e.scrollTop;
}, er = "unmounted", tr = "exited", nr = "entering", rr = "entered", ir = "exiting", Q = /*#__PURE__*/ function(t) {
	Fn(n, t);
	function n(e, n) {
		var r = t.call(this, e, n) || this, i = n, a = i && !i.isMounting ? e.enter : e.appear, o;
		return r.appearStatus = null, e.in ? a ? (o = tr, r.appearStatus = nr) : o = rr : o = e.unmountOnExit || e.mountOnEnter ? er : tr, r.state = { status: o }, r.nextCallback = null, r;
	}
	n.getDerivedStateFromProps = function(e, t) {
		return e.in && t.status === "unmounted" ? { status: tr } : null;
	};
	var r = n.prototype;
	return r.componentDidMount = function() {
		this.updateStatus(!0, this.appearStatus);
	}, r.componentDidUpdate = function(e) {
		var t = null;
		if (e !== this.props) {
			var n = this.state.status;
			this.props.in ? n !== "entering" && n !== "entered" && (t = nr) : (n === "entering" || n === "entered") && (t = ir);
		}
		this.updateStatus(!1, t);
	}, r.componentWillUnmount = function() {
		this.cancelNextCallback();
	}, r.getTimeouts = function() {
		var e = this.props.timeout, t = n = r = e, n, r;
		return e != null && typeof e != "number" && (t = e.exit, n = e.enter, r = e.appear === void 0 ? n : e.appear), {
			exit: t,
			enter: n,
			appear: r
		};
	}, r.updateStatus = function(e, t) {
		if (e === void 0 && (e = !1), t !== null) if (this.cancelNextCallback(), t === "entering") {
			if (this.props.unmountOnExit || this.props.mountOnEnter) {
				var n = this.props.nodeRef ? this.props.nodeRef.current : g.findDOMNode(this);
				n && $n(n);
			}
			this.performEnter(e);
		} else this.performExit();
		else this.props.unmountOnExit && this.state.status === "exited" && this.setState({ status: er });
	}, r.performEnter = function(e) {
		var t = this, n = this.props.enter, r = this.context ? this.context.isMounting : e, i = this.props.nodeRef ? [r] : [g.findDOMNode(this), r], a = i[0], o = i[1], s = this.getTimeouts(), c = r ? s.appear : s.enter;
		if (!e && !n || Yn.disabled) {
			this.safeSetState({ status: rr }, function() {
				t.props.onEntered(a);
			});
			return;
		}
		this.props.onEnter(a, o), this.safeSetState({ status: nr }, function() {
			t.props.onEntering(a, o), t.onTransitionEnd(c, function() {
				t.safeSetState({ status: rr }, function() {
					t.props.onEntered(a, o);
				});
			});
		});
	}, r.performExit = function() {
		var e = this, t = this.props.exit, n = this.getTimeouts(), r = this.props.nodeRef ? void 0 : g.findDOMNode(this);
		if (!t || Yn.disabled) {
			this.safeSetState({ status: tr }, function() {
				e.props.onExited(r);
			});
			return;
		}
		this.props.onExit(r), this.safeSetState({ status: ir }, function() {
			e.props.onExiting(r), e.onTransitionEnd(n.exit, function() {
				e.safeSetState({ status: tr }, function() {
					e.props.onExited(r);
				});
			});
		});
	}, r.cancelNextCallback = function() {
		this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
	}, r.safeSetState = function(e, t) {
		t = this.setNextCallback(t), this.setState(e, t);
	}, r.setNextCallback = function(e) {
		var t = this, n = !0;
		return this.nextCallback = function(r) {
			n && (n = !1, t.nextCallback = null, e(r));
		}, this.nextCallback.cancel = function() {
			n = !1;
		}, this.nextCallback;
	}, r.onTransitionEnd = function(e, t) {
		this.setNextCallback(t);
		var n = this.props.nodeRef ? this.props.nodeRef.current : g.findDOMNode(this), r = e == null && !this.props.addEndListener;
		if (!n || r) {
			setTimeout(this.nextCallback, 0);
			return;
		}
		if (this.props.addEndListener) {
			var i = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback], a = i[0], o = i[1];
			this.props.addEndListener(a, o);
		}
		e != null && setTimeout(this.nextCallback, e);
	}, r.render = function() {
		var t = this.state.status;
		if (t === "unmounted") return null;
		var n = this.props, r = n.children;
		n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
		var i = Nn(n, [
			"children",
			"in",
			"mountOnEnter",
			"unmountOnExit",
			"appear",
			"enter",
			"exit",
			"timeout",
			"addEndListener",
			"onEnter",
			"onEntering",
			"onEntered",
			"onExit",
			"onExiting",
			"onExited",
			"nodeRef"
		]);
		return /*#__PURE__*/ e.createElement(Qn.Provider, { value: null }, typeof r == "function" ? r(t, i) : e.cloneElement(e.Children.only(r), i));
	}, n;
}(e.Component);
Q.contextType = Qn, Q.propTypes = process.env.NODE_ENV === "production" ? {} : {
	nodeRef: Z.default.shape({ current: typeof Element > "u" ? Z.default.any : function(e, t, n, r, i, a) {
		var o = e[t];
		return Z.default.instanceOf(o && "ownerDocument" in o ? o.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, a);
	} }),
	children: Z.default.oneOfType([Z.default.func.isRequired, Z.default.element.isRequired]).isRequired,
	in: Z.default.bool,
	mountOnEnter: Z.default.bool,
	unmountOnExit: Z.default.bool,
	appear: Z.default.bool,
	enter: Z.default.bool,
	exit: Z.default.bool,
	timeout: function(e) {
		var t = Xn;
		e.addEndListener || (t = t.isRequired);
		var n = [...arguments].slice(1);
		return t.apply(void 0, [e].concat(n));
	},
	addEndListener: Z.default.func,
	onEnter: Z.default.func,
	onEntering: Z.default.func,
	onEntered: Z.default.func,
	onExit: Z.default.func,
	onExiting: Z.default.func,
	onExited: Z.default.func
};
function ar() {}
Q.defaultProps = {
	in: !1,
	mountOnEnter: !1,
	unmountOnExit: !1,
	appear: !1,
	enter: !0,
	exit: !0,
	onEnter: ar,
	onEntering: ar,
	onEntered: ar,
	onExit: ar,
	onExiting: ar,
	onExited: ar
}, Q.UNMOUNTED = er, Q.EXITED = tr, Q.ENTERING = nr, Q.ENTERED = rr, Q.EXITING = ir;
//#endregion
//#region node_modules/react-transition-group/esm/CSSTransition.js
var or = function(e, t) {
	return e && t && t.split(" ").forEach(function(t) {
		return Kn(e, t);
	});
}, sr = function(e, t) {
	return e && t && t.split(" ").forEach(function(t) {
		return Jn(e, t);
	});
}, cr = /*#__PURE__*/ function(t) {
	Fn(n, t);
	function n() {
		var e, n = [...arguments];
		return e = t.call.apply(t, [this].concat(n)) || this, e.appliedClasses = {
			appear: {},
			enter: {},
			exit: {}
		}, e.onEnter = function(t, n) {
			var r = e.resolveArguments(t, n), i = r[0], a = r[1];
			e.removeClasses(i, "exit"), e.addClass(i, a ? "appear" : "enter", "base"), e.props.onEnter && e.props.onEnter(t, n);
		}, e.onEntering = function(t, n) {
			var r = e.resolveArguments(t, n), i = r[0], a = r[1] ? "appear" : "enter";
			e.addClass(i, a, "active"), e.props.onEntering && e.props.onEntering(t, n);
		}, e.onEntered = function(t, n) {
			var r = e.resolveArguments(t, n), i = r[0], a = r[1] ? "appear" : "enter";
			e.removeClasses(i, a), e.addClass(i, a, "done"), e.props.onEntered && e.props.onEntered(t, n);
		}, e.onExit = function(t) {
			var n = e.resolveArguments(t)[0];
			e.removeClasses(n, "appear"), e.removeClasses(n, "enter"), e.addClass(n, "exit", "base"), e.props.onExit && e.props.onExit(t);
		}, e.onExiting = function(t) {
			var n = e.resolveArguments(t)[0];
			e.addClass(n, "exit", "active"), e.props.onExiting && e.props.onExiting(t);
		}, e.onExited = function(t) {
			var n = e.resolveArguments(t)[0];
			e.removeClasses(n, "exit"), e.addClass(n, "exit", "done"), e.props.onExited && e.props.onExited(t);
		}, e.resolveArguments = function(t, n) {
			return e.props.nodeRef ? [e.props.nodeRef.current, t] : [t, n];
		}, e.getClassNames = function(t) {
			var n = e.props.classNames, r = typeof n == "string", i = r && n ? n + "-" : "", a = r ? "" + i + t : n[t];
			return {
				baseClassName: a,
				activeClassName: r ? a + "-active" : n[t + "Active"],
				doneClassName: r ? a + "-done" : n[t + "Done"]
			};
		}, e;
	}
	var r = n.prototype;
	return r.addClass = function(e, t, n) {
		var r = this.getClassNames(t)[n + "ClassName"], i = this.getClassNames("enter").doneClassName;
		t === "appear" && n === "done" && i && (r += " " + i), n === "active" && e && $n(e), r && (this.appliedClasses[t][n] = r, or(e, r));
	}, r.removeClasses = function(e, t) {
		var n = this.appliedClasses[t], r = n.base, i = n.active, a = n.done;
		this.appliedClasses[t] = {}, r && sr(e, r), i && sr(e, i), a && sr(e, a);
	}, r.render = function() {
		var t = this.props;
		t.classNames;
		var n = Nn(t, ["classNames"]);
		return /*#__PURE__*/ e.createElement(Q, Mn({}, n, {
			onEnter: this.onEnter,
			onEntered: this.onEntered,
			onEntering: this.onEntering,
			onExit: this.onExit,
			onExiting: this.onExiting,
			onExited: this.onExited
		}));
	}, n;
}(e.Component);
cr.defaultProps = { classNames: "" }, cr.propTypes = process.env.NODE_ENV === "production" ? {} : Mn({}, Q.propTypes, {
	classNames: Zn,
	onEnter: Z.default.func,
	onEntering: Z.default.func,
	onEntered: Z.default.func,
	onExit: Z.default.func,
	onExiting: Z.default.func,
	onExited: Z.default.func
});
//#endregion
//#region node_modules/@dnd-kit/modifiers/dist/modifiers.esm.js
function lr(e, t, n) {
	let r = { ...e };
	return t.top + e.y <= n.top ? r.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (r.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? r.x = n.left - t.left : t.right + e.x >= n.left + n.width && (r.x = n.left + n.width - t.right), r;
}
var ur = (e) => {
	let { transform: t, draggingNodeRect: n, windowRect: r } = e;
	return !n || !r ? t : lr(t, n, r);
}, dr = .5;
function fr(e) {
	if (!e) return;
	let { left: t, top: n, right: r, bottom: i } = e.getBoundingClientRect();
	return {
		left: t,
		top: n,
		right: r,
		bottom: i
	};
}
function pr(e, t) {
	return !e || !t ? e === t : e.left === t.left && e.top === t.top && e.right === t.right && e.bottom === t.bottom;
}
function mr({ direction: e, dialogRect: t, gripSize: n = 8, viewport: r }) {
	let i = r ?? hr(t), a = e.includes("n"), o = e.includes("e"), s = e.includes("s"), c = e.includes("w");
	return {
		position: "absolute",
		left: c ? -(n - gr("w", t, n, i)) : o ? void 0 : n,
		right: o ? -(n - gr("e", t, n, i)) : c ? void 0 : n,
		width: o || c ? n : void 0,
		top: a ? -(n - gr("n", t, n, i)) : s ? void 0 : n,
		bottom: s ? -(n - gr("s", t, n, i)) : a ? void 0 : n,
		height: a || s ? n : void 0,
		cursor: vr(e)
	};
}
function hr(e) {
	return typeof window < "u" ? {
		width: window.innerWidth,
		height: window.innerHeight
	} : {
		width: e.right,
		height: e.bottom
	};
}
function gr(e, t, n, r) {
	let i = _r(e, t, r), a = Math.max(0, n - i), o = Math.floor(n * dr);
	return Math.min(a, o);
}
function _r(e, t, n) {
	switch (e) {
		case "n": return Math.max(0, t.top);
		case "e": return Math.max(0, n.width - t.right);
		case "s": return Math.max(0, n.height - t.bottom);
		case "w": return Math.max(0, t.left);
	}
}
function vr(e) {
	switch (e) {
		case "ne":
		case "sw": return "nesw-resize";
		case "nw":
		case "se": return "nwse-resize";
		case "n":
		case "s": return "ns-resize";
		case "e":
		case "w": return "ew-resize";
	}
}
//#endregion
//#region src/Resizable.tsx
var yr = {
	width: 8,
	height: 8
};
function br(e) {
	let { enabled: t } = e;
	return t.x || t.y ? /* @__PURE__ */ m(Cr, { ...e }) : e.children;
}
var xr = {
	n: {
		x: 0,
		y: -1
	},
	e: {
		x: 1,
		y: 0
	},
	s: {
		x: 0,
		y: 1
	},
	w: {
		x: -1,
		y: 0
	},
	ne: {
		x: 1,
		y: -1
	},
	nw: {
		x: -1,
		y: -1
	},
	se: {
		x: 1,
		y: 1
	},
	sw: {
		x: -1,
		y: 1
	}
}, Sr = {
	x: "width",
	y: "height"
};
function Cr({ children: e, container: t, position: n, setPosition: r, size: i, setSize: o, minSize: s = yr, enabled: c, origin: u }) {
	let d = f(void 0), [g, _] = p(void 0), v = a((e) => {
		let { left: n, top: r, width: i, height: a } = t.current.getBoundingClientRect();
		d.current = {
			initialPosition: {
				left: n,
				top: r,
				width: i,
				height: a
			},
			direction: e.active.id
		};
	}, [t]), y = a(() => {
		d.current = void 0;
	}, []), b = a((e) => {
		let t = (t, n) => {
			let r = Sr[t], i = d.current.initialPosition, a = Math.max(s[r], i[r] + n * e.delta[t]);
			o((e) => ({
				...e ?? {},
				[r]: a
			}));
		}, n = xr[e.active.id];
		n.x !== 0 && t("x", n.x), n.y !== 0 && t("y", n.y);
	}, [s, o]);
	l(() => {
		if (d.current) {
			let e = d.current.initialPosition, n = t.current.getBoundingClientRect(), { width: i, height: a } = n, { left: o, top: s } = n, c = window.innerWidth - n.right, l = window.innerHeight - n.bottom, f = xr[d.current.direction];
			f.x < 0 && u.x === "left" && (o = e.left - (i - e.width)), f.x > 0 && u.x === "right" && (c = window.innerWidth - (e.left + e.width) - (i - e.width)), f.y < 0 && u.y === "top" && (s = e.top - (a - e.height)), f.y > 0 && u.y === "bottom" && (l = window.innerHeight - (e.top + e.height) - (a - e.height)), r({
				[u.x]: u.x === "left" ? o : c,
				[u.y]: u.y === "top" ? s : l
			});
		}
	}, [
		t,
		u,
		r,
		i
	]);
	let x = a(() => {
		_((e) => {
			let n = fr(t.current);
			return pr(e, n) ? e : n;
		});
	}, [t]);
	return l(() => {
		let e = t.current;
		if (!e) {
			_(void 0);
			return;
		}
		x();
		let n = new ResizeObserver(x);
		return n.observe(e), window.addEventListener("resize", x), () => {
			n.disconnect(), window.removeEventListener("resize", x);
		};
	}, [t, x]), l(() => {
		x();
	}, [
		n,
		i,
		x
	]), /* @__PURE__ */ h(En, {
		onDragStart: v,
		onDragMove: b,
		onDragEnd: y,
		modifiers: [ur],
		children: [
			e,
			g && c.y && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				n: !0
			}),
			g && c.y && c.x && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				n: !0,
				e: !0
			}),
			g && c.x && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				e: !0
			}),
			g && c.x && c.y && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				e: !0,
				s: !0
			}),
			g && c.y && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				s: !0
			}),
			g && c.y && c.x && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				s: !0,
				w: !0
			}),
			g && c.x && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				w: !0
			}),
			g && c.x && c.y && /* @__PURE__ */ m(wr, {
				dialogRect: g,
				w: !0,
				n: !0
			})
		]
	});
}
function wr({ dialogRect: e, n: t, w: n, e: r, s: i, size: a = 8 }) {
	let o = t ? r ? "ne" : n ? "nw" : "n" : i ? r ? "se" : n ? "sw" : "s" : r ? "e" : "w", { setNodeRef: s, listeners: c, attributes: l } = An({ id: o });
	return /* @__PURE__ */ m("div", {
		ref: s,
		style: u(() => mr({
			direction: o,
			dialogRect: e,
			gripSize: a
		}), [
			e,
			o,
			a
		]),
		...c,
		...l
	});
}
//#endregion
//#region src/dnd.ts
var Tr = ({ nativeEvent: e }) => {
	let t = e.target;
	for (; t;) {
		if (t.dataset && t.dataset.noDnd) return !1;
		t = t.parentElement;
	}
	return !0;
}, Er = class extends kt {
	static activators = [{
		eventName: "onPointerDown",
		handler: Tr
	}];
}, Dr = {
	dialog: "_dialog_cp573_1",
	position: "_position_cp573_7",
	titlebar: "_titlebar_cp573_11",
	content: "_content_cp573_17",
	transitionWrapper: "_transitionWrapper_cp573_22"
}, Or = ({ transform: e, draggingNodeRect: t, windowRect: n }) => {
	if (!t || !n) return e;
	let r = t.left + e.x, i = t.top + e.y, a = r + t.width, o = i + t.height, s = e.x, c = e.y;
	return a < 50 && (s = e.x + (50 - a)), r > n.width - 50 && (s = e.x - (r - (n.width - 50))), o < 50 && (c = e.y + (50 - o)), i > n.height - 50 && (c = e.y - (i - (n.height - 50))), {
		...e,
		x: s,
		y: c
	};
}, kr = r(function(e, t) {
	let [n, r] = p({});
	c(t, () => ({ autoResize: () => r({}) }), []);
	let { portal: i } = ae(), a = {
		...e,
		autoResizeTrigger: n
	};
	return i ? _(/* @__PURE__ */ m(Ar, { ...a }), i) : /* @__PURE__ */ m(Ar, { ...a });
});
function Ar(e) {
	let t = Le(Ie(Er), Ie(wt)), [n, r] = p(void 0), i = f(void 0);
	return /* @__PURE__ */ m(En, {
		sensors: t,
		onDragStart: a(({ active: { data: e } }) => {
			let { left: t, top: n } = (e.current?.sizeRef).current.getBoundingClientRect();
			i.current = {
				left: t,
				top: n
			};
		}, []),
		onDragEnd: a(({ delta: e }) => {
			r(() => {
				if (i.current) return j(i.current, ([[t, n], [r, i]]) => ({
					[t]: n + e.x,
					[r]: i + e.y
				}));
			});
		}, []),
		modifiers: [Or],
		children: /* @__PURE__ */ m(jr, {
			...e,
			position: n,
			setPosition: r
		})
	});
}
function jr({ children: e, title: t, classNames: n, position: r, positionHint: i, sizeHint: o, setPosition: s, visible: c = !0, fadeClassNames: d, fadeDuration: g = 0, rememberPosition: _ = !1, resizable: v = !1, minmaxSize: y, fitViewportHeight: b = !0, autoResizeTrigger: x }) {
	let S = k(), C = Nr(S), w = f(null), [T, E] = p(void 0), { raiseDialog: D, defaultPositionHint: O, portal: ee } = ae(), A = i ?? O, te = u(() => typeof v == "boolean" ? {
		x: v,
		y: v
	} : {
		x: !!v.x,
		y: !!v.y
	}, [v]), N = u(() => {
		let e = r ?? A;
		return e ? M(e) : {
			x: "left",
			y: "top"
		};
	}, [r, A]), ne = u(() => ({
		x: N.x,
		y: N.y
	}), [N.x, N.y]);
	Mr({
		id: S,
		position: r,
		setPosition: s,
		positionHint: A,
		sizeRef: w,
		visible: c,
		origin: ne
	});
	let { setNodeRef: P, listeners: re, transform: ie, attributes: F, setActivatorNodeRef: I, active: L } = An({
		id: "dialog",
		data: { sizeRef: w }
	}), R = u(() => {
		let { height: e } = (ee ?? document.body).getBoundingClientRect();
		return e;
	}, [ee]), z = u(() => ({
		...r ? j(r, ([[e, t], [n, r]]) => ({
			[e]: `${t}px`,
			[n]: `${r}px`
		})) : A,
		transform: Se.Translate.toString(ie),
		position: "fixed",
		zIndex: C
	}), [
		r,
		A,
		ie,
		C
	]), oe = u(() => {
		let e = {};
		return T?.width !== void 0 && (e.width = `${T.width}px`), T?.height !== void 0 && (e.height = `${T.height}px`), {
			...o,
			...e,
			...b ? { maxHeight: R - 16 } : {},
			...y
		};
	}, [
		b,
		R,
		y,
		T,
		o
	]), B = a(() => {
		_ || s(void 0);
	}, [_, s]), se = f(null);
	return l(() => {
		E(void 0);
	}, [x]), /* @__PURE__ */ m(cr, {
		timeout: g,
		classNames: d,
		mountOnEnter: !0,
		onExited: B,
		in: c,
		nodeRef: se,
		appear: !0,
		children: (i) => /* @__PURE__ */ m("div", {
			className: Dr.position,
			ref: w,
			style: {
				...z,
				display: i === "exited" && !c ? "none" : "block"
			},
			children: /* @__PURE__ */ m(br, {
				enabled: te,
				container: w,
				position: r,
				setPosition: s,
				size: T,
				setSize: E,
				origin: ne,
				children: /* @__PURE__ */ m("div", {
					ref: se,
					className: Dr.transitionWrapper,
					children: /* @__PURE__ */ h("div", {
						className: (0, jn.default)(Dr.dialog, n.dialog, L && n.active),
						ref: P,
						style: oe,
						onMouseDown: () => D(S),
						children: [/* @__PURE__ */ m("div", {
							className: (0, jn.default)(Dr.titlebar, n.titlebar),
							ref: I,
							...re,
							...F,
							children: t
						}), /* @__PURE__ */ m("div", {
							className: (0, jn.default)(Dr.content, n.content),
							children: e
						})]
					})
				})
			})
		})
	});
}
function Mr({ id: e, position: t, setPosition: n, positionHint: r, sizeRef: i, visible: a, origin: o }) {
	let { dialogs: c, nextPosition: u, rearrangeTrigger: d } = ae(), p = f(void 0);
	l(() => {
		let e = i.current;
		a && e && t && (p.current = e.getBoundingClientRect(), n(void 0));
	}, [
		d,
		n,
		i
	]), l(() => {
		if (i.current && a) {
			let { width: a, height: s, left: l, top: d } = i.current.getBoundingClientRect();
			if (t) c.set(e, { rect: {
				left: l,
				top: d,
				width: a,
				height: s
			} });
			else {
				let t = u({
					width: a,
					height: s
				}, {
					positionHint: r && {
						left: l,
						top: d
					},
					origin: o
				}), f = A(t, {
					width: a,
					height: s
				});
				if (c.set(e, { rect: {
					...f,
					width: a,
					height: s
				} }), n(t), p.current) {
					let e = A(p.current, {
						width: a,
						height: s
					}), t = f, n = e.left - t.left, r = e.top - t.top;
					i.current?.animate?.([{ transform: `translate(${n}px, ${r}px)` }, { transform: "translate(0, 0)" }], {
						duration: 200,
						easing: "cubic-bezier(0.25, 1, 0.5, 1)"
					}), p.current = void 0;
				}
			}
			return () => {
				c.delete(e);
			};
		} else c.delete(e);
	}, [
		c,
		e,
		u,
		o,
		t,
		r,
		n,
		i,
		a
	]), s(() => {
		let t = i.current;
		if (t && a) {
			let n = new ResizeObserver(() => {
				let { width: n, height: r, left: i, top: a } = t.getBoundingClientRect();
				c.set(e, { rect: {
					left: i,
					top: a,
					width: n,
					height: r
				} });
			});
			return n.observe(t), () => {
				n.unobserve(t);
			};
		} else c.delete(e);
	}, [
		c,
		e,
		i,
		a
	]);
}
function Nr(e) {
	let { zIndex: t } = ae();
	return t.has(e) || t.set(e, t.size), s(() => () => {
		t.delete(e);
	}, [e, t]), t.get(e);
}
var $ = {
	dialog: "_dialog_k2km0_1",
	active: "_active_k2km0_10",
	titlebar: "_titlebar_k2km0_14",
	titlebarText: "_titlebarText_k2km0_24",
	titlebarCloseButton: "_titlebarCloseButton_k2km0_28",
	content: "_content_k2km0_41",
	enter: "_enter_k2km0_45",
	appear: "_appear_k2km0_46",
	enterActive: "_enterActive_k2km0_51",
	appearActive: "_appearActive_k2km0_52",
	enterDone: "_enterDone_k2km0_58",
	appearDone: "_appearDone_k2km0_59",
	exit: "_exit_k2km0_63",
	exitActive: "_exitActive_k2km0_67",
	exitDone: "_exitDone_k2km0_73"
}, Pr = {
	dialog: $.dialog,
	titlebar: $.titlebar,
	content: $.content,
	active: $.active
}, { appear: Fr, appearActive: Ir, appearDone: Lr, enter: Rr, enterActive: zr, enterDone: Br, exit: Vr, exitActive: Hr, exitDone: Ur } = $, Wr = {
	appear: Fr,
	appearActive: Ir,
	appearDone: Lr,
	enter: Rr,
	enterActive: zr,
	enterDone: Br,
	exit: Vr,
	exitActive: Hr,
	exitDone: Ur
};
function Gr({ title: e, onCloseButtonClick: n, resizeButton: r, ...i }) {
	let o = a(() => {
		c.current?.autoResize();
	}, []), s = u(() => n ? /* @__PURE__ */ h(t, { children: [
		/* @__PURE__ */ m("div", {
			className: $.titlebarText,
			children: e
		}),
		r && /* @__PURE__ */ m("button", {
			className: $.titlebarCloseButton,
			"data-no-dnd": !0,
			onClick: o,
			children: "+"
		}),
		/* @__PURE__ */ m("button", {
			className: $.titlebarCloseButton,
			"data-no-dnd": !0,
			onClick: n,
			children: "×"
		})
	] }) : e, [
		o,
		n,
		e,
		r
	]), c = f(null);
	return /* @__PURE__ */ m(kr, {
		ref: c,
		classNames: Pr,
		title: s,
		fadeClassNames: Wr,
		fadeDuration: 200,
		...i
	});
}
//#endregion
//#region src/index.ts
var Kr = { y: !0 }, qr = { x: !0 };
//#endregion
export { Gr as DarkDialog, kr as Dialog, L as DialogContext, qr as resizableX, Kr as resizableY };

//# sourceMappingURL=react-draggable-dialog.es.js.map